module.exports = __webpack_public_path__ + "img/BlinkArt_Axe2H_Basic.be1afbc9.png";